import { useState } from "react";
import type { UseSectionDisclosure } from "./types";

export const useSectionDisclosure: UseSectionDisclosure = ({
  isOpen,
  onOpenChange,
}) => {
  const [isOpenLocally, setIsOpenLocally] = useState(false);
  const isPanelOwned = isOpen !== undefined;
  const resolvedIsOpen = isPanelOwned ? isOpen : isOpenLocally;

  const set = (next: boolean) => {
    // Only one place holds the answer: a section the panel drives must not also
    // keep a second one of its own that nothing reconciles.
    if (!isPanelOwned) setIsOpenLocally(next);
    onOpenChange?.(next);
  };

  return {
    isOpen: resolvedIsOpen,
    toggle: () => set(!resolvedIsOpen),
    open: () => set(true),
  };
};
